import React, { createContext, useState, useEffect } from 'react';
import db from '../../lib/db';

const IDBcontext = createContext();

export const IDBProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      //iz idb u kontekst stejt
      const allItems = await db.items;
      if (allItems) {
        setItems(allItems);
      } else {
        // console.warn('No db items');
        return;
      }
    };
    loadData();
  }, []);

  const addItem = async (newItem) => {
    try {
      const id = await db.items.add(newItem);
      setItems([...items, { ...newItem, id }]);
    } catch (error) {
      console.error("Failed to add item to the database", error);
    }
  };
  const removeItem = async (itemId) => {
    try {
      await db.items.delete(itemId);
      setItems(items.filter(item => item.id !== itemId));
    } catch (error) {
      console.error("Failed to delete item from the database", error);
    }
  };
  const updateItem = async (itemId, updates) => {
    try {
      await db.items.update(itemId, updates);
      setItems(items.map(item => item.id === itemId ? { ...item, ...updates } : item));
    } catch (error) {
      console.error("Failed to update item in the database", error);
    }
  };


  const valueToShare = {
    items: items,
    addItem: addItem,
    removeItem: removeItem,
    updateItem: updateItem
  }
  return (
    <IDBcontext.Provider value={valueToShare}>
      {children}
    </IDBcontext.Provider>
  );
};
export default IDBcontext;